import { ThemeEvents } from '@theme/events';

/**
 * Keeps the product page's own custom-liquid bits (the SKU line and the stock badge) in step
 * with the selected variant. Horizon re-renders only its built-in blocks on a variant change,
 * so these stayed on the first variant. Elements marked [data-variant-refresh="name"] take
 * their content from the page HTML the variant picker has already fetched, so the Liquid in
 * templates/product.json stays the only place the markup is written.
 */
document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const html = event.detail?.data?.html;
  if (!html || !(event.target instanceof Element)) return;

  const scope = event.target.closest('.shopify-section, dialog') || document;
  for (const element of scope.querySelectorAll('[data-variant-refresh]')) {
    const name = /** @type {HTMLElement} */ (element).dataset.variantRefresh;
    const fresh = html.querySelector(`[data-variant-refresh="${name}"]`);
    if (fresh) element.innerHTML = fresh.innerHTML;
  }
});
